import { render, staticRenderFns } from "./MessageArea.html?vue&type=template&id=52965b9a&scoped=true&"
import script from "./MessageArea.js?vue&type=script&lang=js&"
export * from "./MessageArea.js?vue&type=script&lang=js&"
import style0 from "./MessageArea.scss?vue&type=style&index=0&id=52965b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52965b9a",
  null
  
)

export default component.exports